// Webrtc plugin.
import * as actionTypes from '../actionTypes'

// Libraries.
import { isEmpty } from 'lodash/fp'

function mediaActionHelper (type, id, payload = {}, meta = {}) {
  const action = {
    type,
    payload: {
      ...payload,
      id
    }
  }

  // Only have meta and error properties on the action if they're needed.
  if (!isEmpty(meta)) {
    action.meta = meta
  }
  if (payload.error) {
    action.error = true
  }
  return action
}

export function newMedia (id, params) {
  return mediaActionHelper(actionTypes.MEDIA_NEW, id, params)
}

export function removedMedia (id, params) {
  return mediaActionHelper(actionTypes.MEDIA_REMOVED, id, params)
}

export function mediaNewTrack (id, params) {
  return mediaActionHelper(actionTypes.MEDIA_NEW_TRACK, id, params)
}

export function mediaTrackEnded (id, params) {
  return mediaActionHelper(actionTypes.MEDIA_TRACK_ENDED, id, params)
}
